"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmergencyRoom = void 0;
var tslib_1 = require("tslib");
var qs_1 = tslib_1.__importDefault(require("qs"));
var base_service_1 = require("../base-service");
var utils_1 = require("../utils");
var EmergencyRoom = /** @class */ (function (_super) {
    tslib_1.__extends(EmergencyRoom, _super);
    function EmergencyRoom() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTeams = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = '/teams';
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.getTeamEpisodes = function (teamId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/teams/".concat(teamId, "/episodes");
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.getEpisode = function (episodeId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/episodes/".concat(episodeId);
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.uploadUrlPatientMedicalId = function (patientId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/patients/".concat(patientId, "/medical_id/upload");
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.downloadUrlPatientMedicalId = function (patientId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/patients/".concat(patientId, "/medical_id/download");
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.uploadUrlMyMedicalId = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = '/patients/me/medical_id/upload';
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.downloadUrlMyMedicalId = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = '/patients/me/medical_id/download';
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.markAllEpisodesAsResolved = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/episodes/resolve_all_active";
                        return [4 /*yield*/, this.api.post(url, {})];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.dispatchEpisode = function (episodeId, teamId, teamActionId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/episodes/".concat(episodeId, "/team");
                        return [4 /*yield*/, this.api.post(url, {
                                team_id: teamId,
                                team_action_id: teamActionId,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.getEpisodeProperties = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/episode-properties";
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getEpisodes = function (state, offset, limit, resolvedByMe) {
            if (offset === void 0) { offset = 0; }
            if (limit === void 0) { limit = 10; }
            if (resolvedByMe === void 0) { resolvedByMe = false; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var url, params, response;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = '/episodes';
                            params = { state: state, offset: offset, limit: limit, resolved_by_me: resolvedByMe };
                            return [4 /*yield*/, this.api.get(url, params)];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, this.handleResponse(null, url, response)];
                    }
                });
            });
        };
        _this.getMyAssignedEpisodes = function (state, offset, limit) {
            if (offset === void 0) { offset = 0; }
            if (limit === void 0) { limit = 10; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var url, params, response;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = '/practitioners/me/episodes';
                            params = { state: state, offset: offset, limit: limit };
                            return [4 /*yield*/, this.api.get(url, params)];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, this.handleResponse(null, url, response)];
                    }
                });
            });
        };
        _this.getMyEpisodes = function (offset, limit) {
            if (offset === void 0) { offset = 0; }
            if (limit === void 0) { limit = 50; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var url, params, response;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/patients/me/episodes";
                            params = { offset: offset, limit: limit };
                            return [4 /*yield*/, this.api.get(url, params)];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, this.handleResponse(null, url, response)];
                    }
                });
            });
        };
        _this.getEpisodesByPatient = function (patient_id, offset, limit, filter_by_subject_id) {
            if (offset === void 0) { offset = 0; }
            if (limit === void 0) { limit = 100; }
            if (filter_by_subject_id === void 0) { filter_by_subject_id = false; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var url, params, response;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/patients/".concat(patient_id, "/episodes");
                            params = { offset: offset, limit: limit, filter_by_subject_id: filter_by_subject_id };
                            return [4 /*yield*/, this.api.get(url, params)];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, this.handleResponse(null, url, response)];
                    }
                });
            });
        };
        _this.getPatientEpisodesByIds = function (patient_id, episode_ids) {
            if (episode_ids === void 0) { episode_ids = []; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var url, params, response;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/patients/".concat(patient_id, "/episodes_by_ids");
                            params = { episode_ids: episode_ids };
                            return [4 /*yield*/, this.api.get(url, params, {
                                    paramsSerializer: function (p) { return qs_1.default.stringify(p, { arrayFormat: 'repeat' }); },
                                })];
                        case 1:
                            response = _a.sent();
                            return [2 /*return*/, this.handleResponse(null, url, response)];
                    }
                });
            });
        };
        _this.archiveEpisode = function (episode_id) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/episodes/".concat(episode_id, "/archive");
                        return [4 /*yield*/, this.api.post(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.getReminderTags = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = '/reminder_tags';
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.updateReminderStatus = function (reminder_id, status) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/reminders/".concat(reminder_id, "/status");
                        return [4 /*yield*/, this.api.post(url, {
                                status: status,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.getEpisodeReminders = function (episode_id) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/episodes/".concat(episode_id, "/reminders");
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.postReminder = function (payload) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/reminders";
                        return [4 /*yield*/, this.api.post(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.getReminders = function (status, offset, limit, 
        /**
         * `due_on` format shall follow "YYYY-MM-DD"
         *
         * Example: "2020-04-25"
         */
        due_on, search, 
        /**
         * Return all reminders or only those created by
         * requesting user
         */
        createdByMe) {
            if (offset === void 0) { offset = 0; }
            if (limit === void 0) { limit = 10; }
            if (due_on === void 0) { due_on = null; }
            if (search === void 0) { search = null; }
            if (createdByMe === void 0) { createdByMe = false; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var url, params, response;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/reminders";
                            params = {
                                status: status,
                                offset: offset,
                                limit: limit,
                                due_on: due_on,
                                search: search,
                                created_by_me: createdByMe,
                            };
                            return [4 /*yield*/, this.api.get(url, params)];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, this.handleResponse(null, url, response)];
                        case 2: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        _this.checkAccessToPatientRecord = function (patientId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/patients/".concat(patientId, "/access");
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.requestAccessToPatientRecord = function (patientId, reCaptchaResponse) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/patients/".concat(patientId, "/access");
                        return [4 /*yield*/, this.api.post(url, {
                                recaptcha_response: reCaptchaResponse,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.updateEpisodeProperties = function (episodeId, properties) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/episodes/".concat(episodeId, "/properties");
                        return [4 /*yield*/, this.api.post(url, properties)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.updateEpisodeTitle = function (episodeId, title) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/episodes/".concat(episodeId, "/title");
                        return [4 /*yield*/, this.api.post(url, {
                                title: title,
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.createMeEpisode = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/patients/me/episodes";
                        return [4 /*yield*/, this.api.post(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.createEpisode = function (patientId, communication_methods) {
            if (communication_methods === void 0) { communication_methods = null; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var url, body, response, data;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/patients/".concat(patientId, "/episodes");
                            body = communication_methods ? { communication_methods: communication_methods } : undefined;
                            return [4 /*yield*/, this.api.post(url, body)];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, this.handleResponse(null, url, response)];
                        case 2:
                            data = (_a.sent()).data;
                            return [2 /*return*/, data];
                    }
                });
            });
        };
        _this.getOrCreateIcbtEpisode = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/patients/me/icbt_episode";
                        return [4 /*yield*/, this.api.post(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, { data: data, status: response.status }];
                }
            });
        }); };
        _this.assignEpisode = function (episode_id, practitionerId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/episodes/".concat(episode_id, "/assignee");
                        return [4 /*yield*/, this.api.post(url, {
                                assignee_id: practitionerId,
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.unassignEpisode = function (episode_id) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/episodes/".concat(episode_id, "/assignee");
                        return [4 /*yield*/, this.api.delete(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.setEpisodeState = function (episodeId, stateId, outcomeId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, payload, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/episodes/".concat(episodeId, "/state");
                        payload = { state_id: stateId };
                        if (outcomeId) {
                            payload.outcome_id = outcomeId;
                        }
                        return [4 /*yield*/, this.api.post(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.requestEpisodeAccess = function (episodeUrl) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, payload, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = 'episodes/request_access';
                        payload = { url: episodeUrl };
                        return [4 /*yield*/, this.api.post(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, this.handleResponse(null, url, response)];
                }
            });
        }); };
        _this.getPractitionerSpecializations = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/app-data/practitioner-specializations";
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getAllPractitioners = function (status_since) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, params, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/practitioners/";
                        params = { status_since: status_since };
                        return [4 /*yield*/, this.api.get(url, params)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getPractitionerStatusOptions = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/app-data/practitioner-status";
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getPractitioner = function (practitionerId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/practitioners/".concat(practitionerId);
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.updatePractitioner = function (practitionerId, props) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/practitioners/".concat(practitionerId);
                        return [4 /*yield*/, this.api.put(url, props)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getLicenses = function (practitionerId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/practitioners/".concat(practitionerId, "/licenses");
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.createLicense = function (practitionerId, newLicense) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/practitioners/".concat(practitionerId, "/licenses");
                        return [4 /*yield*/, this.api.post(url, newLicense)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.updateLicense = function (practitionerId, licenseId, updatedLicense) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/practitioners/".concat(practitionerId, "/licenses/").concat(licenseId);
                        return [4 /*yield*/, this.api.put(url, updatedLicense)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.deleteLicense = function (practitionerId, licenseId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/practitioners/".concat(practitionerId, "/licenses/").concat(licenseId);
                        return [4 /*yield*/, this.api.delete(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getMyPatientProfile = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = '/patients/me/';
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getPatientProfile = function (patientId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/patients/".concat(patientId);
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.updatePatient = function (patientId, data) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/patients/".concat(patientId);
                        return [4 /*yield*/, this.api.patch(url, data)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2: return [2 /*return*/, (_a.sent()).data];
                }
            });
        }); };
        /**
         * @deprecated use notepad to fetch care plans
         */
        _this.getMyEncounters = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = '/patients/me/encounters';
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getLiveblocksToken = function (roomId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/liveblocks/token/".concat(encodeURIComponent(roomId));
                        return [4 /*yield*/, this.api.post(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.joinEpisode = function (episodeId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/episodes/".concat(episodeId, "/join");
                        return [4 /*yield*/, this.api.post(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getOrCreateWbiEpisode = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/patients/me/wbi_episode";
                        return [4 /*yield*/, this.api.post(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, { data: data, status: response.status }];
                }
            });
        }); };
        _this.createTask = function (payload) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/tasks/";
                        return [4 /*yield*/, this.api.post(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getTasks = function (episodeId, status) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/tasks/";
                        return [4 /*yield*/, this.api.get(url, {
                                episode_id: episodeId,
                                status: status,
                            })];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.updateTaskDetails = function (taskId, payload) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/tasks/".concat(taskId);
                        return [4 /*yield*/, this.api.patch(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.updateTaskStatus = function (taskId, payload) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/tasks/".concat(taskId, "/status");
                        return [4 /*yield*/, this.api.post(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getTaskTeams = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/tasks/teams";
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getQuestionnaires = function (memberId, params) {
            if (params === void 0) { params = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var url, response;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/members/".concat(memberId, "/properties/questionnaires");
                            return [4 /*yield*/, this.api.get(url, params)];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, this.handleResponse(null, url, response)];
                        case 2: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        _this.getMemberProperties = function (memberId, params) {
            if (params === void 0) { params = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var url, response;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/members/".concat(memberId, "/properties");
                            return [4 /*yield*/, this.api.get(url, (0, utils_1.serializeQueryParams)(params))];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, this.handleResponse(null, url, response)];
                        case 2: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        _this.setMemberAllergies = function (memberId, payload) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/members/".concat(memberId, "/properties/allergies");
                        return [4 /*yield*/, this.api.post(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.setMemberMedications = function (memberId, payload) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/members/".concat(memberId, "/properties/medications");
                        return [4 /*yield*/, this.api.post(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.setMemberMedicalHistory = function (memberId, payload) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/members/".concat(memberId, "/properties/medical_history");
                        return [4 /*yield*/, this.api.post(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getMemberNotes = function (memberId, params) {
            if (params === void 0) { params = {}; }
            return tslib_1.__awaiter(_this, void 0, void 0, function () {
                var url, response;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            url = "/members/".concat(memberId, "/member_notes");
                            return [4 /*yield*/, this.api.get(url, params)];
                        case 1:
                            response = _a.sent();
                            return [4 /*yield*/, this.handleResponse(null, url, response)];
                        case 2: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        _this.createMemberNote = function (memberId, payload) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/members/".concat(memberId, "/member_notes");
                        return [4 /*yield*/, this.api.post(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.updateMemberNote = function (memberId, noteId, payload) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/members/".concat(memberId, "/member_notes/").concat(noteId);
                        return [4 /*yield*/, this.api.patch(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.deleteMemberNote = function (memberId, noteId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/members/".concat(memberId, "/member_notes/").concat(noteId);
                        return [4 /*yield*/, this.api.delete(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        }); };
        _this.getStructuredMedications = function (memberId) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/members/".concat(memberId, "/structured_medications");
                        return [4 /*yield*/, this.api.get(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.createStructuredMedication = function (memberId, payload) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/members/".concat(memberId, "/structured_medications");
                        return [4 /*yield*/, this.api.post(url, payload)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        }); };
        _this.getOrCreateHealthProfileEpisode = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var url, response, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = "/patients/me/health_profile_episode";
                        return [4 /*yield*/, this.api.post(url)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.handleResponse(null, url, response)];
                    case 2:
                        data = (_a.sent()).data;
                        return [2 /*return*/, { data: data, status: response.status }];
                }
            });
        }); };
        return _this;
    }
    return EmergencyRoom;
}(base_service_1.BaseService));
exports.EmergencyRoom = EmergencyRoom;
